import { render, staticRenderFns } from "./CreatedFile.vue?vue&type=template&id=3d2a3091&scoped=true"
import script from "./CreatedFile.vue?vue&type=script&lang=js"
export * from "./CreatedFile.vue?vue&type=script&lang=js"
import style0 from "./CreatedFile.vue?vue&type=style&index=0&id=3d2a3091&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a3091",
  null
  
)

export default component.exports